import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AiSparkle24 = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M11.2667 3.41479C11.4364 2.62474 12.5636 2.62475 12.7333 3.4148L13.5946 7.42593C13.9152 8.91872 15.0813 10.0848 16.5741 10.4054L20.5852 11.2667C21.3753 11.4364 21.3753 12.5636 20.5852 12.7333L16.5741 13.5946C15.0813 13.9152 13.9152 15.0813 13.5946 16.5741L12.7333 20.5852C12.5636 21.3753 11.4364 21.3753 11.2667 20.5852L10.4054 16.5741C10.0848 15.0813 8.91872 13.9152 7.42593 13.5946L3.41479 12.7333C2.62474 12.5636 2.62475 11.4364 3.4148 11.2667L7.42593 10.4054C8.91872 10.0848 10.0848 8.91872 10.4054 7.42593L11.2667 3.41479Z"
      fill="url(#paint0_linear_26845_234525)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_26845_234525"
        x1="21.3754"
        y1="5.04027e-07"
        x2="2.62457"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="0.0667" stopColor="#FE4D81" />
        <stop offset="0.1333" stopColor="#FC4E82" />
        <stop offset="0.2" stopColor="#F95086" />
        <stop offset="0.2667" stopColor="#F4528A" />
        <stop offset="0.3333" stopColor="#EE5490" />
        <stop offset="0.4" stopColor="#E65897" />
        <stop offset="0.4667" stopColor="#DE5B9F" />
        <stop offset="0.5333" stopColor="#D65FA7" />
        <stop offset="0.6" stopColor="#CE62AF" />
        <stop offset="0.6667" stopColor="#C666B6" />
        <stop offset="0.7333" stopColor="#C068BC" />
        <stop offset="0.8" stopColor="#BB6AC0" />
        <stop offset="0.8667" stopColor="#B86CC4" />
        <stop offset="0.9333" stopColor="#B66DC5" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
